<template>
  <div>
    <div class="mt-5">
      <div class="b-form__container_type_flex">
        <h4>{{$t('CONTENT.discountRates.discount')}}</h4>
        <dynamic-icon class="ml-1" v-tooltip="$t('CONTENT.hints.discountHint')" icon="question"></dynamic-icon>
      </div>
      <div class="row mt-2 b-form__container_type_flex b-form__row_type_flex-end">
        <div class="col-4">
          <label>{{$t('CONTENT.percent')}}:<span class="b-form__required"> *</span></label>
          <numeric
            v-bind:class="{ 'b-numeric__error': isFieldWithError('discountPercent', discountPercent) }"
            class="b-numeric"
            controls :min="0" :max="100"
            v-model="discountPercent"/>
        </div>
        <div class="col-4 b-form__container_type_flex">
          <checkbox
            class="b-checkbox"
            id="isAuto"
            v-model="discountIsAuto">{{$t('CONTENT.discountRates.isAutoDiscount')}}</checkbox>
          <dynamic-icon class="ml-1" v-tooltip="$t('CONTENT.hints.isAutoDiscountHint')" icon="question"></dynamic-icon>
        </div>
      </div>
      <div class="row mt-5 b-form__container_type_flex b-form__row_type_flex-end">
        <div class="col-6">
          <div>
            <label>{{$t('CONTENT.comment')}}:</label>
            <textarea class="b-textarea" v-model.lazy="discountComment"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  props: {
    payment: {
      type: Object
    },
    validationErrors: {
      type: Array
    },
    assetComponent: {
      type: Object
    },
  },
  created() {
    if (this.payment.discount.discountRate !== null) return
    const paymentsParameters = this.assetComponent.lessorComponentShares
      .flatMap(l => l.paymentsParameters)
      .filter(payment => payment.discount.discountRate !== null)

    if(paymentsParameters.length === 0) return
    this.payment.discount.discountRate = paymentsParameters[0].discount.discountRate
  },
  computed: {
    ...mapGetters(["getCurrentContract"]),
    ...mapGetters(["getContractEventState"]),
    isDisabledSetDiscountRate() {
      return !!this.discountIsAuto;
    },
    isContractEventState() {
      return this.getContractEventState;
    },
    autoDiscountDisabled() {
      if(!this.isContractEventState) return false
      const discounts = this.getAllDiscounts()
      return this.getAllDiscounts().every(discount => discount.isAuto) || discounts.every(discount => !discount.isAuto)
    },
    discountPercent: {
      get() {
        if (this.payment.discount.discountRate !== null) {
          return this.payment.discount.discountRate;
        }
      },
      set(newVal) {
        if(isNaN(newVal)) {
          this.payment.discount.discountRate = null;
        } else {
          this.payment.discount.discountRate = newVal;
        }
      }
    },
    discountIsAuto: {
      get() {
        if(this.isContractEventState) {
          this.payment.discount.isAuto = this.getAllDiscounts().every(discount => discount.isAuto)
        }

        return this.payment.discount.isAuto
      },
      set(newVal) {
        this.payment.discount.isAuto = newVal;
      }
    },
    discountComment: {
      get() {
        if (this.payment.discount.commentary !== null) {
          return this.payment.discount.commentary;
        }
      },
      set(newVal) {
        this.payment.discount.commentary = newVal;
      }
    },
    discountFieldDisabled() {
      return this.isDisabledSetDiscountRate
        || (this.isContractEventState && this.payment.discount.discountRate !== null)
    }
  },
  watch: {
    discountIsAuto(newVal) {
      if(newVal) {
        this.payment.discount.discountRate = null;
      }
    }
  },
  methods: {
    isFieldWithError(field, value) {
      return !value && this.validationErrors && this.validationErrors.includes(field);
    },
    getAllDiscounts() {
      return this.getCurrentContract.assetComponents
        .flatMap(assetComponent => assetComponent.lessorComponentShares)
        .flatMap(lessorComponentShare => lessorComponentShare.paymentsParameters)
        .map(payment => payment.discount)
    }
  },
};
</script>
